export default {"src":"/_next/static/media/Business.eeadb580.svg","height":24,"width":24,"blurWidth":0,"blurHeight":0};